import settingsTabs from "./settingsTabs";

// Get Tab Id based on Tab Slug
const getTabId = input => {
    const foundTab = settingsTabs.find(tab => tab.slug === input);
    return foundTab ? foundTab.id : null;
}

// Get Tab Slug based on Tab Id
const getTabSlug = id => {
    const tab = settingsTabs.find(tab => tab.id === id);
    return tab ? tab.slug : null;
};

export {
    getTabId,
    getTabSlug,
};